import {yupResolver} from "@hookform/resolvers/yup";
import React, {useEffect} from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import {Alert} from "@/components/alert/Alert.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ServerErrors} from "@/lib/types/common.ts";

interface UpdateExternalUserFormValues {
  first_name: string;
  last_name: string;
  email: string;
}

type FormValuesKey = keyof UpdateExternalUserFormValues;

const FormSchema = Yup.object({
  first_name: Yup.string().max(150).required("This field is required"),
  last_name: Yup.string().max(150).required("This field is required"),
  email: Yup.string().max(150).required("This field is required"),
});

interface AddExternalUserFormProps {
  formId: string;
  onSubmit: (d: UpdateExternalUserFormValues) => void;
  onError?: (errors: FieldErrors<UpdateExternalUserFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

export const AddExternalUserForm = ({formId, onSubmit, onError, serverErrors}: AddExternalUserFormProps) => {
  const methods = useForm<UpdateExternalUserFormValues>({
    resolver: yupResolver<UpdateExternalUserFormValues>(FormSchema),
  });
  const {setError, handleSubmit} = methods;

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => {
          setError(key as FormValuesKey, {message: serverErrors[key][0]});
        });
    }
  }, [setError, serverErrors]);

  return (
    <FormProvider {...methods}>
      <form id={formId} onSubmit={handleSubmit(onSubmit, onError)}>
        {serverErrors?.__all__ && <FormErrorAlerts errors={serverErrors?.__all__} />}
        <InputField name="first_name" className="mb-3" label="First Name" required />
        <InputField name="last_name" className="mb-3" label="Last Name" required />
        <InputField name="email" className="mb-4" label="Email Address" required />
        <Alert className={"mb-0"} variant={"maintenance"}>
          <span className="pulseTextBody">
            An email invite will be sent to this address with a link for creating a password.
          </span>
        </Alert>
      </form>
    </FormProvider>
  );
};
